import React from 'react';
    import { motion } from 'framer-motion';
    import * as FiIcons from 'react-icons/fi';
    import SafeIcon from '../common/SafeIcon';
    import Navigation from '../components/Navigation';
    import CosmicBackground from '../components/CosmicBackground';

    const { FiStar, FiZap, FiArrowRight } = FiIcons;

    const PremiumLandingPage = () => {
      const handleProLinkClick = () => {
        window.open('https://link.fastpaydirect.com/payment-link/68f0315a67ee3bf26569ef0a', '_blank');
      };

      return (
        <div className="min-h-screen bg-gray-900 text-white relative overflow-hidden">
          <CosmicBackground />
          <Navigation />

          <section className="pt-32 pb-20 relative z-10 flex items-center justify-center min-h-[80vh]">
            <div className="container mx-auto px-6">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="text-center bg-gradient-to-r from-cyan-900/40 to-blue-900/40 p-12 rounded-3xl border border-cyan-500/30 backdrop-blur-sm max-w-3xl mx-auto"
              >
                <div className="w-16 h-16 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <SafeIcon icon={FiStar} className="text-white text-2xl" />
                </div>
                <h1 className="text-4xl md:text-5xl font-orbitron font-bold mb-4">
                  Unlock <span className="clarity-gradient">Premium Tools</span>
                </h1>
                <p className="text-lg text-gray-300 font-poppins mb-8 max-w-2xl mx-auto">
                  You've discovered a premium tool. Unlock its full power,along with 45+ other AI-powered tools,by
                  joining one of our plans.
                </p>
                <div className="grid md:grid-cols-2 gap-6 bg-gray-900/30 p-6 rounded-2xl mb-8">
                  <div className="text-left">
                    <h3 className="font-orbitron text-xl font-bold text-green-400 mb-2">Clarity Club</h3>
                    <p className="text-gray-400 text-sm mb-3">Community,resources,and access to all free &amp;a limited number of premium Prompt Tools.</p>
                    <p className="text-2xl font-bold text-white">$5.55<span className="text-base font-normal text-gray-400">/month</span></p>
                  </div>
                  <div className="text-left">
                    <h3 className="font-orbitron text-xl font-bold text-purple-400 mb-2">Link In Bio Pro</h3>
                    <p className="text-gray-400 text-sm mb-3">Everything in Clarity Club,plus a branded affiliate system,business tools,and full access to all premium Prompt Tools.</p>
                    <p className="text-2xl font-bold text-white">$33<span className="text-base font-normal text-gray-400">/month</span></p>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
                  <a href="https://discord.withjahx.com" target="_blank" rel="noopener noreferrer">
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      className="bg-gradient-to-r from-green-600 to-emerald-600 px-8 py-4 rounded-full font-poppins font-semibold text-lg glow-button flex items-center justify-center space-x-2 w-full sm:w-auto"
                    >
                      <span>Join Clarity Club</span>
                      <SafeIcon icon={FiArrowRight} />
                    </motion.button>
                  </a>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={handleProLinkClick}
                    className="bg-gradient-to-r from-purple-600 to-blue-600 px-8 py-4 rounded-full font-poppins font-semibold text-lg glow-button flex items-center justify-center space-x-2 w-full sm:w-auto"
                  >
                    <SafeIcon icon={FiZap} />
                    <span>Get Link in Bio Pro</span>
                  </motion.button>
                </div>
              </motion.div>
            </div>
          </section>
        </div>
      );
    };

    export default PremiumLandingPage;